import { render, staticRenderFns } from "./ProposalProductGrid.vue?vue&type=template&id=1c636bb0"
import script from "./ProposalProductGrid.vue?vue&type=script&lang=js"
export * from "./ProposalProductGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports